<div class="header__title">
  {{title}}
  @if (currentEnvironment.Key != '') {
    <span
      class="header__environment kt__badgeEnvironment--{{currentEnvironment.Key}}"
      >
      {{currentEnvironment.Badge}}
    </span>
  }
</div>
